import { get } from "lodash";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { KEYS, GTM_CLIENTS } from "utils/constants";
import { sendEnhancedConversion } from "utils/helpers/googleAdsHelpers";
import Loader from "../Components/Loader";
import View from "./View";

const ElectronicSignature = ({ project, onNext, onBack, updateUrl }) => {
  const subscriptionId =
    localStorage.getItem(KEYS.SUBSCRIPTION_ID) ||
    get(project, "fields.currentSubscription");
  const { data, loading } = useQuery(graphql.queries.SUBSCRIPTION, {
    variables: { where: { id: subscriptionId } },
  });
  const [updateSubscription] = useMutation(
    graphql.mutations.UPDATE_SUBSCRIPTION,
    {
      variables: { where: { id: subscriptionId }, data: { locked: true } },
    },
  );
  const signatureLink = get(data, "subscription.signature.signatureLink");

  if (loading || !signatureLink) return <Loader />;

  const next = (_ = {}) => {
    updateSubscription();
    const source = localStorage.getItem(KEYS.SOURCE);
    updateUrl({
      subscriptionId,
      url: get(
        data,
        "subscription.insurancePlan.config.generatedUrl",
        `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${source}`,
      ),
    });
    onNext({
      payload: {},
      onCompleted: () => {
        sendEnhancedConversion(
          project,
          GTM_CLIENTS.SOLYON.CONVERSION_SUBMISSION,
        );
      },
    });
  };

  return (
    <View
      onNext={next}
      user={get(project, "contact.user")}
      onBack={onBack}
      signatureLink={signatureLink}
    />
  );
};

export default ElectronicSignature;
